import { MenuItemInfo } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { PoolNodePresenceIcon } from '../dataConnectPoolNodes/PoolNodePresenceIcon';
import { gePoolNodeStatus } from '../dataConnectPoolNodes/PoolNodeStates';
import { PoolNodeStatus } from '../dataConnectPoolNodes/PoolNodeStatus';
import { ActionItemInfo, ActionItemType, ActionType, MoreActionsMenu } from '../MoreActionsMenu';
import { Node } from '../types/Node';
import { UserDefinedPoolModel } from '../types/PoolModel';
import { openDeletePoolDialog } from './DeletePoolDialog';
import { openEditPoolDialog } from './EditPoolDialog';
import { GenerateNodeScriptButton } from './GenerateNodeScriptButton';
import { openGetDockerRegistryDialog } from './GetDockerRegistryAction';
import { PoolNamePopover } from './PoolNamePopover';
import { openRefreshBaseImageDialog } from './RefreshBaseImageAction';
import { openRefreshTokensDialog } from './RefreshTokensDialog';

export type MultiPoolTableEntryPoolProps = Readonly<{
  pool: UserDefinedPoolModel;
  existingPoolNames: ReadonlyArray<string>;
  isExpanded: boolean;
  siteId: string;
  refreshBaasEdgePools: () => void;
}>;

export function DataConnectMultiPoolTableEntryPool(props: MultiPoolTableEntryPoolProps) {
  const { pool, existingPoolNames, isExpanded, siteId, refreshBaasEdgePools } = props;
  const nodes: Node[] = pool.cluster.nodes.concat();
  let poolStyle = tableCellMaxWidth + ' tb-data-grid-separator-row ';
  let poolStylewithMinWidth = tableCellMinMaxWidth + ' tb-data-grid-separator-row ';
  poolStyle += isExpanded ? expandedRowFocus : '';
  poolStylewithMinWidth += isExpanded ? expandedRowFocus : '';
  const targetSelectItem: MenuItemInfo[] = [
    { displayValue: Messages.dataConnectSiteSettingsEditPoolNameButton(), value: ActionType.EDIT_POOL_NAME },
    { displayValue: Messages.dataConnectSiteSettingsRefreshTokensButton(), value: ActionType.REFRESH_TOKEN, disabled: disableRefreshTokenButton(pool.status) },
    { displayValue: Messages.dataConnectSiteSettingsGetDockerRegistryButton(), value: ActionType.GET_DOCKER_REGISTRY, disabled: disableRefreshBaseImageAndGetDockerRegistryButton(pool.status) },
    { displayValue: Messages.dataConnectSiteSettingsRefreshBaseImageButton(), value: ActionType.REFRESH_BASE_IMAGE, disabled: disableRefreshBaseImageAndGetDockerRegistryButton(pool.status) },
    { displayValue: Messages.deleteMessage(), value: ActionType.DELETE },
  ];
  const poolNodeStatus = gePoolNodeStatus();
  return <>
    <td className={poolStyle}>
      <PoolNamePopover pool={pool}/>
    </td>
    <td className={poolStylewithMinWidth}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'pool-empty-column-cell'}>
      &nbsp;
      </span>
    </td>
    <td className={poolStyle}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'pool-status-cell'}>
        {<PoolNodePresenceIcon status={pool.status} poolNodeStatus={poolNodeStatus} />}
        {poolNodeStatus[pool.status].stateLabel}
      </span>
    </td>
    <td className={poolStyle}>
      <span className={'tb-data-grid-cell-text tb-lr-padded-wide'} data-tb-test-id={'pool-status-cell'}>
        <GenerateNodeScriptButton pool={pool} existingPoolNames={existingPoolNames} siteId={siteId} />
        {!isExpanded && <><MoreActionsMenu
          targetItemInfo={targetSelectItem}
          actionType= {ActionItemType.NODE_ACTION}
          actionItemInfo={{poolId: pool.poolId, poolName: pool.displayName,
                        clusterId: pool.clusterId,
                        domains: pool.domains,
                        siteId: siteId, refreshBaasEdgePools: refreshBaasEdgePools}}
          onHandleMenuSelect={onHandleMenuSelect}
        /></>
        }
       </span>
    </td>
  </>;
}

const onHandleMenuSelect = (actionItem: ActionItemInfo, actionType: string) => {
  if (actionType === ActionType.DELETE) {
    openDeletePoolDialog(actionItem, actionItem.refreshBaasEdgePools);
  } else if (actionType === ActionType.EDIT_POOL_NAME) {
    openEditPoolDialog(actionItem, actionItem.refreshBaasEdgePools);
  } else if (actionType === ActionType.REFRESH_TOKEN) {
    openRefreshTokensDialog(actionItem);
  } else if (actionType === ActionType.REFRESH_BASE_IMAGE) {
    openRefreshBaseImageDialog(actionItem);
  } else if (actionType === ActionType.GET_DOCKER_REGISTRY) {
    openGetDockerRegistryDialog(actionItem);
  }
};

export const expandedRowFocus = style({
    backgroundColor: CommonStyles.Colors.BlueHighlight
  });

 const tableCellMaxWidth = style({
  maxWidth: 200,
  overflow: 'hidden',
});

 const tableCellMinMaxWidth = style({
  maxWidth: 200,
  overflow: 'hidden',
  minWidth: 180
});

const disableRefreshTokenButton = (poolStatus: PoolNodeStatus) => {
    return !(poolStatus === PoolNodeStatus.TOKEN_EXPIRED ||
      poolStatus === PoolNodeStatus.TOKEN_WILL_EXPIRE);
};

const disableRefreshBaseImageAndGetDockerRegistryButton = (poolStatus: PoolNodeStatus) => {
  return poolStatus !== PoolNodeStatus.READY;
};